import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';
import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import RnaId from '../RnaId';

import './ListingValuePropositionModal.scss';

const ListingValuePropositionModal = ({
  isOpen,
  onRequestClose,
  chipList = [],
  landlordDescription = '',
  listingDescription = '',
  roomDescription = '',
  rnaIdFeature = null
}) => {
  const propertyChips = chipList.filter(chip => !chip.isGuarantee);

  const guaranteeChips = chipList.filter(chip => chip.isGuarantee);

  return (
    <Modal onRequestClose={onRequestClose} isOpen={isOpen} size="medium">
      <ModalHeader
        showClose
        onRequestClose={onRequestClose}
        label={trans('listing.value.proposition.title')}
        className="listing-value-proposition-modal__header"
      />
      <ModalBody className="listing-value-proposition-modal__body">
        {propertyChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title')}
            </ListingTitle>
            <ListingChipsList chipList={propertyChips} />
          </div>
        )}
        {guaranteeChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title.always')}
            </ListingTitle>
            <ListingChipsList chipList={guaranteeChips} />
          </div>
        )}
        {landlordDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.landlord.description.title')}
            </ListingTitle>
            <ListingContent content={landlordDescription} />
          </div>
        )}
        {listingDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.description.title')}
            </ListingTitle>
            <ListingContent content={listingDescription} />
          </div>
        )}
        {roomDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.room_description')}
            </ListingTitle>
            <ListingContent content={roomDescription} />
          </div>
        )}
        {rnaIdFeature && rnaIdFeature?.value !== 'no' && (
          <RnaId
            className="listing-value-proposition-modal__section listing-value-proposition-modal__section-rna-id-content"
            rnaIdFeature={rnaIdFeature}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

ListingValuePropositionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  chipList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      icon: PropTypes.string,
      value: PropTypes.bool,
      order: PropTypes.number,
      subtext: PropTypes.string
    })
  ),
  landlordDescription: PropTypes.string,
  listingDescription: PropTypes.string,
  roomDescription: PropTypes.string,
  rnaIdFeature: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.string
  })
};

export default ListingValuePropositionModal;
